import React from 'react';
import { Link } from 'react-router-dom';

const AudioPlay = () => {
    return (
        <div className="flex justify-center items-center min-h-screen">

            <div className="bg-white p-6 sm:p-8 w-full max-w-7xl">
            <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                Lesson 1: What is the Science of Reading?
            </h3>

            <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                Phonemic Awareness
            </h3>

            <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                <p className="lg:pl-2">What is Phonemic Awareness?</p>
                <ul className="list-disc lg:pl-10 pt-2">
                    <li>
                        Phonemic Awareness is the ability to identify the individual letters in the alphabet within
                        a word and separately.
                    </li>
                </ul>
            </div>

            {/* First Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl w-full">

                {/* Card 1 */}
                <div className="sound-button bg-primary rounded-xl p-6 text-center cursor-pointer shadow-md transition-all">
                    <div className="text-white text-sm flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-1 mt-1" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 1C7 1 3 5 3 10V17C3 18.1 3.9 19 5 19H7C8.1 19 9 18.1 9 17V14C9 12.9 8.1 12 7 12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H17C15.9 12 15 12.9 15 14V17C15 18.1 15.9 19 17 19H19C20.1 19 21 18.1 21 17V10C21 5 17 1 12 1Z"/>
                        </svg>
                        Press to Listen
                    </div>
                    <div className="text-white text-5xl font-bold mb-2">Aa</div>
                </div>

                {/* Card 2 */}
                <div className="sound-button bg-[#D5B641] rounded-xl p-6 text-center cursor-pointer shadow-md transition-all">
                    <div className="text-white text-sm flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-1 mt-1" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 1C7 1 3 5 3 10V17C3 18.1 3.9 19 5 19H7C8.1 19 9 18.1 9 17V14C9 12.9 8.1 12 7 12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H17C15.9 12 15 12.9 15 14V17C15 18.1 15.9 19 17 19H19C20.1 19 21 18.1 21 17V10C21 5 17 1 12 1Z"/>
                        </svg>
                        Press to Listen
                    </div>
                    <div className="text-white text-5xl font-bold mb-2">Mm</div>
                </div>

                {/* Card 3 */}
                <div className="sound-button bg-[#374957] rounded-xl p-6 text-center cursor-pointer shadow-md transition-all">
                    <div className="text-white text-sm flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-1 mt-1" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 1C7 1 3 5 3 10V17C3 18.1 3.9 19 5 19H7C8.1 19 9 18.1 9 17V14C9 12.9 8.1 12 7 12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H17C15.9 12 15 12.9 15 14V17C15 18.1 15.9 19 17 19H19C20.1 19 21 18.1 21 17V10C21 5 17 1 12 1Z"/>
                        </svg>
                        Press to Listen
                    </div>
                    <div className="text-white text-5xl font-bold mb-2">Vv</div>
                </div>

            </div>

            {/* Section 2 */}
            <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left mt-10 mb-6">
                <ul className="list-disc lg:pl-10 pt-2">
                    <li>The ability to manipulate individual sounds into combinations or blends.</li>
                </ul>
            </div>

            {/* Second Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl w-full">

                {/* Card 1 */}
                <div className="sound-button bg-primary rounded-xl p-6 text-center cursor-pointer shadow-md transition-all">
                    <div className="text-white text-sm flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-1 mt-1" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 1C7 1 3 5 3 10V17C3 18.1 3.9 19 5 19H7C8.1 19 9 18.1 9 17V14C9 12.9 8.1 12 7 12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H17C15.9 12 15 12.9 15 14V17C15 18.1 15.9 19 17 19H19C20.1 19 21 18.1 21 17V10C21 5 17 1 12 1Z"/>
                        </svg>
                        Press to Listen
                    </div>
                    <div className="text-white text-5xl font-bold mb-2">BI</div>
                </div>

                {/* Card 2 */}
                <div className="sound-button bg-[#D5B641] rounded-xl p-6 text-center cursor-pointer shadow-md transition-all">
                    <div className="text-white text-sm flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-1 mt-1" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 1C7 1 3 5 3 10V17C3 18.1 3.9 19 5 19H7C8.1 19 9 18.1 9 17V14C9 12.9 8.1 12 7 12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H17C15.9 12 15 12.9 15 14V17C15 18.1 15.9 19 17 19H19C20.1 19 21 18.1 21 17V10C21 5 17 1 12 1Z"/>
                        </svg>
                        Press to Listen
                    </div>
                    <div className="text-white text-5xl font-bold mb-2">Sc</div>
                </div>

                {/* Card 3 */}
                <div className="sound-button bg-[#374957] rounded-xl p-6 text-center cursor-pointer shadow-md transition-all">
                    <div className="text-white text-sm flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-1 mt-1" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 1C7 1 3 5 3 10V17C3 18.1 3.9 19 5 19H7C8.1 19 9 18.1 9 17V14C9 12.9 8.1 12 7 12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H17C15.9 12 15 12.9 15 14V17C15 18.1 15.9 19 17 19H19C20.1 19 21 18.1 21 17V10C21 5 17 1 12 1Z"/>
                        </svg>
                        Press to Listen
                    </div>
                    <div className="text-white text-5xl font-bold mb-2">Tw</div>
                </div>

            </div>

            {/* Buttons */}
            <div className="flex justify-end mt-5">
                <Link to="/dashboard/modules/quiz-fail">
                    <button className="px-6 py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-8">
                        ← Previous
                    </button>
                </Link>

                <Link to="/dashboard/modules/image-or-gif">
                    <button className="px-6 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                        Continue Lesson →
                    </button>
                </Link>
            </div>
        </div>
        </div>
    );
};

export default AudioPlay;
